import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
          漫画分类
        </h2>
        <Link to="/category/romance" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
          全部分类 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
          >
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-400">{cat.count}部</span>
          </Link>
        ))}
      </div>
    </section>
  );
}